<!-- -------New Html (no-sites & application added)------------ -->
<div class="not_added" *ngIf="emptyMsg">
  <div class="user_img">
    <img src="./assets/img-new/siteapp.png" alt="client" />
  </div>
  <h4>No sites & applications added yet</h4>
  <button mat-raised-button color="primary" (click)="addClients()">
    <span class="sprite_icon plus_white"></span>
    <span>Add Sites & Applications</span>
  </button>
</div>
<!--------------->

<!-- -------New Html (sites & application listing)------------ -->
<span *ngIf="showList">
  <div class="breadcrumb_outer">
    <ul class="breadcrumb">
      <li>
        <a>{{ company_name }}:</a>
      </li>
      <li class="active"><a>Sites & Applications</a></li>
    </ul>
    <div class="right">
      <span>{{ today }}</span>
    </div>
  </div>
  <div class="tag_powered_by">
    <span>Powered by: <b>Enertics</b></span>
  </div>
  <div class="Content_outer">
    <div class="content_view">
      <div class="row">
        <div class="col-md-12">
          <div class="listing_outer SA_list">
            <div class="filter_div">
              <div class="top">
                <h4>Sites & Applications</h4>
                <div class="right">
                  <div class="custom_search width_250">
                    <span class="sprite_icon search"></span>
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="searchedItem"
                      placeholder="Search By: Site name"
                      (input)="searchData($event.target.value)"
                    />
                  </div>
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="addClients()"
                  >
                    <span class="sprite_icon plus_white"></span>
                    <span>Add Sites & Applications</span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="listing_box three_col heading"
              *ngIf="showEmptyError == ''"
            >
              <h4 class="left">Sites</h4>
              <h4
                class="center"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <div class="">Applications</div>
                <div class="">Device Count</div>
              </h4>
              <h4 class="right"></h4>
            </div>
            <p
              *ngIf="showEmptyError !== ''"
              style="
                font-size: 16px;
                color: #838383;
                text-align: center;
                padding: 30px;
              "
            >
              {{ showEmptyError }}
            </p>

            <div
              class="listing_box three_col"
              *ngFor="let site of siteArr; let i = index"
            >
              <h4 class="left">{{ site?.name || "0" }}</h4>
              <div
                class="center"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <div class="">
                  <span
                    class="app_names"
                    *ngFor="let application of site.applications"
                    >{{ application.name }}<font>,</font></span
                  >
                </div>
                <div class="" style="margin-right: 35px">
                  {{ site.device_count }}
                </div>
              </div>
              <div class="actions dropdown right">
                <button
                  class="btn dropdown-toggle"
                  type="button"
                  [matMenuTriggerFor]="menu"
                  data-toggle="dropdown"
                >
                  <span class="sprite_icon ellipse_black"></span>
                </button>
                <mat-menu #menu="matMenu">
                  <div class="client_action">
                    <div class="menu-item-container">
                      <button mat-stroked-button color="primary" (click)="editSiteGroup(site)" class="edit-button stroked-menu-button">
                        <mat-icon>edit</mat-icon>
                        <span>Edit</span>
                      </button>
                    </div>
                    <div class="menu-item-container">
                      <button mat-stroked-button color="warn" (click)="showDeleteDialog(site, i)" class="delete-button stroked-menu-button">
                        <mat-icon>delete</mat-icon>
                        <span>Delete</span>
                      </button>
                    </div>
                  </div>
                </mat-menu>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</span>
